/* eslint-disable import/no-anonymous-default-export */
export default (locationMonthlyQuantity = [], action) => {
  switch (action.type) {
    case "LOCATION_STOCK_ISSUED_MONTHLY":
      return action.payload;

    default:
      return locationMonthlyQuantity;
  }
};
